import { render, staticRenderFns } from "./tixian.vue?vue&type=template&id=347cd361&scoped=true&"
import script from "./tixian.vue?vue&type=script&lang=js&"
export * from "./tixian.vue?vue&type=script&lang=js&"
import style0 from "./tixian.vue?vue&type=style&index=0&id=347cd361&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "347cd361",
  null
  
)

export default component.exports